import { NgModule } from '@angular/core';
import {
  Routes,
  RouterModule
} from '@angular/router';
import { PUBLIC_ROUTE, LAYOUT_ROUTE } from './constants/routes.constants';
import { PublicGuard, LayoutGuard } from './guards';


const routes: Routes = [
  {
    path: '',
    redirectTo: PUBLIC_ROUTE.path,
    pathMatch: 'full'
  },
  {
    path: PUBLIC_ROUTE.path,
    loadChildren: () => import('./modules/accounts/accounts.module').then(m => m.AccountsModule)
    , canLoad: [PublicGuard],
    canActivate: [PublicGuard],
  },
  {
    path: 'accept-invitation',
    loadChildren: () => import('./modules/accounts/pages/accept-invitation/accept-invitation.module').then(m => m.AcceptInvitationModule)
  },
  {
    path: LAYOUT_ROUTE.path,
    loadChildren: () => import('./modules/layouts/layouts.module').then(m => m.LayoutsModule)
    , canLoad: [LayoutGuard],
    canActivate: [LayoutGuard],
  },
  { path: '**', loadChildren: () => import('./modules/not-found/not-found.module').then(m => m.NotFoundModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
